module.exports = __webpack_public_path__ + "img/Loading1.11ab5abc.gif";